import React from 'react';
import {bool, func, object, string} from 'prop-types';
import {DragSource, DropTarget} from 'react-dnd';
import {FormattedMessage} from 'react-intl';
import {Button, Grid, Segment} from 'semantic-ui-react';
import compose from 'recompose/compose';
import {isEqual} from "utils/DBUtils";
import {EmptyFunc} from "../../utils/DBUtils";

const stepDragSource = {
  beginDrag: props => ({
    id: props.id,
    originalIndex: props.findStep(props.id).index
  }),
  endDrag: (props, monitor) => {
    const { id: draggedId } = monitor.getItem();
    const { id: overId } = monitor.getDropResult();

    if (monitor.didDrop() && draggedId !== overId) {
      const { index: overIndex } = props.findStep(overId);
      props.moveStep(draggedId, overIndex);
    }
  }
};

const stepDropTarget = {
  drop: (props, monitor) => props
};



const MasterStep = ({
  onClick,
  active,
  stepType,
  stepLabel,
  sortable,
  isDragging, // for styling, if needed
  breakObj,
  connectDragSource,
  connectDropTarget,
  deleteStep,
  togglePublishStep,
  renameStep
}) => {
  const step = (
    <div onClick={onClick}>
      <Segment>
        <Grid>
          <Grid.Row className="master-step-row">
            <Grid.Column width={9} className="master-step-title">
              Step: {stepLabel || <FormattedMessage id={"step_types." + stepType.toLowerCase()}/>}
              <br/>
              <ul className="platform-icons">
                  { breakObj.hasOwnProperty('DAILYBREAK') ? <li className={"web-icon" + ( isEqual(breakObj.DAILYBREAK,breakObj.MASTER) ? " different" : "")} /> : "" }
                  { breakObj.hasOwnProperty('DEMO') ? <li className={"demo-icon" + ( isEqual(breakObj.DEMO,breakObj.MASTER) ? " different" : "")} /> : "" }
                  { breakObj.hasOwnProperty('EMBED') ? <li className={"embed-icon" + ( isEqual(breakObj.EMBED,breakObj.MASTER) ? " different" : "")} /> : "" }
              </ul>
            </Grid.Column>
            <Grid.Column width={7} className="master-step-buttons">
              <Button className='hyperlink-button'
                      onClick={(event) => {
                        event.stopPropagation();
                        deleteStep();
                      }}>
                Delete
              </Button>
              <br/>
              <Button className='hyperlink-button'
                      onClick={(event) => {
                          event.stopPropagation();
                          renameStep();
                      }}>
                Rename step
              </Button>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Segment>
    </div>
  );

  return sortable ? connectDragSource(connectDropTarget(step)) : step;
};

MasterStep.propTypes = {
  id: string,
  stepType: string,
  stepLabel: string,
  stepCheck: object,
  sortable: bool,
  breakObj: object,
  connectDragSource: func.isRequired,
  connectDropTarget: func.isRequired,
  isDragging: bool.isRequired,
  findStep: func.isRequired,
  moveStep: func.isRequired,
  deleteStep: func,
  togglePublishStep: func,
  renameStep: func,
  onClick: func
};

MasterStep.defaultProps = {
  deleteStep: EmptyFunc,
  deactivateStep: EmptyFunc,
  renameStep: EmptyFunc,
  onClick: EmptyFunc
};

export default compose(
  DropTarget('masterStep', stepDropTarget, connect => ({
    connectDropTarget: connect.dropTarget()
  })),
  DragSource('masterStep', stepDragSource, (connect, monitor) => ({
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging()
  }))
)(MasterStep);



// WEBPACK FOOTER //
// ./public/components/steps/MasterStep.jsx